import { StatusBadge } from "@/components/dashboard/widgets/shared/StatusBadge";
import { EQUIPMENT_STATUS_LABELS, type EquipmentStatus } from "@/lib/equipment/constants";

/** Tilgjengelig er grønn, service og savnet røde, solgt og utrangert grå. */
export function EquipmentStatusBadge({ status }: { status: EquipmentStatus }) {
  const label = EQUIPMENT_STATUS_LABELS[status];
  if (status === "ok") return <StatusBadge tone="reached" label={label} />;
  if (status === "in_service" || status === "missing") return <StatusBadge tone="miss" label={label} />;
  return (
    <span className="inline-flex items-center text-[11.5px] font-semibold px-2.5 py-0.5 rounded-full whitespace-nowrap bg-muted text-muted-foreground">
      {label}
    </span>
  );
}
